import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { TokenStorageService } from '../../../core/services/token-storage.service';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);
  private readonly tokenStorage = inject(TokenStorageService);
  private readonly router = inject(Router);

  readonly navItems: NavItem[] = [
    { path: '/dashboard', label: 'داشبورد', icon: 'grid' },
    { path: '/users', label: 'کاربران', icon: 'users' },
    { path: '/notifications', label: 'نوتیفیکیشن', icon: 'bell' },
  ];

  get adminName(): string {
    return this.tokenStorage.currentUser()?.displayName || 'مدیر';
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => this.router.navigateByUrl('/login'),
      error: () => {
        this.authService.forceLocalLogout();
        this.router.navigateByUrl('/login');
      },
    });
  }
}
